import { BffApiClientMolecule } from "@/app/api-client/store"
import { BlockchainFiltersMoleculeReatom } from "@/app/blockchains/filters/blockchain-filters-molecule.reatom"
import { computed } from "@reatom/core"
import { molecule } from "bunshi"
import { NftFiltersMoleculeReatom } from "../filters/store.reatom"
import { NftSearchScope } from "../scope"
import { NftSortMoleculeReatom } from "../sort/store.reatom"
import { type QueryInput, getNftSearchQueryParams } from "./utils"

export const NftSearchResultMoleculeReatom = molecule((mol, scope) => {
  const bffApiClient = mol(BffApiClientMolecule)
  const { sortAtom } = mol(NftSortMoleculeReatom)
  const { allFilters } = mol(NftFiltersMoleculeReatom)
  const { pageSize } = scope(NftSearchScope)
  const { blockchainsQueryFilter } = mol(BlockchainFiltersMoleculeReatom)

  // Computed query input for TanStack Query
  const queryInput = computed(() => {
    const filters = allFilters()
    const blockchains = filters.blockchains || blockchainsQueryFilter()

    const input: QueryInput = {
      sort: sortAtom(),
      filters: {
        ...filters,
        blockchains,
      },
    }

    if (pageSize !== undefined) {
      input.pageSize = pageSize
    }

    return input
  }, "nftSearchQueryInput")

  // Query params atom for TanStack Query
  const nftSearchQueryParamsAtom = computed(
    () => ({
      ...getNftSearchQueryParams(bffApiClient, queryInput()),
      refetchInterval: 5000,
    }),
    "nftSearchQueryParams",
  )

  return {
    nftSearchQueryParamsAtom,
  }
})
